module.exports = __webpack_public_path__ + "assets/img/a7ac-uz.svg";